import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * Randomly shuffles the list
 *
 * @param list array that needs to be shuffled
 * @returns array shuffled items in random order
 */
export default function shuffle(list) {
  var currentIndex = list.length;
  var randomIndex;
  var copyList = _toConsumableArray(list);
  while (currentIndex != 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    var _ref = [copyList[randomIndex], copyList[currentIndex]];
    copyList[currentIndex] = _ref[0];
    copyList[randomIndex] = _ref[1];
  }
  return copyList;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/shuffle.js
// module id = 2612
// module chunks = 11